import * as React from 'react';
import WebcamReact from 'react-webcam';
import {decode as decodeBase64} from 'base-64'; 
import { Grid } from '@mui/material';
import { Button, Media, Transition } from '.';


interface Props {
  id?: string;
  audio?: boolean;
  shotTimeout?: number;
  hide?: boolean;
  stop?: boolean;
  height?: number;
  width?: number;
  getImage?: (data: any) => void;
  getPermission?: (data: any) => void;
}

export const Webcam: React.FunctionComponent<Props> = (props) => {

    const videoConstraints = { aspectRatio: 0.6666666667, facingMode: 'user', height: props.height || 100, width: props.width || 100 }
    const [img, setImg] = React.useState<string|null>(null);
    const width = props.width || 200;
    const height = props.height || 200;
    const webcamRef = React.useRef<WebcamReact>(null);
    
    const captureImage = React.useCallback(() => {
      const image = webcamRef.current?.getScreenshot() || null;
      setImg(image);

      const convertToUint8 = (data: string) => {
        const decodeResult = decodeBase64(data);
        var n = decodeResult.length;
        const u8arr = new Uint8Array(n);
        while(n--){ u8arr[n] = decodeResult.charCodeAt(n); }
        return u8arr;
      }

      const imgSplit = { 
        value : image,
        mime  : image?.split(',')[0].split(':')[1].split(';')[0],
        bytes : image?.split(',')[1],
        uint8 : convertToUint8(image?.split(',')[1] || '')
      }
      props.getImage?.(imgSplit);
    }, [props, webcamRef]);

    const getPermission = () => {
      props.getPermission?.(null);
      navigator.mediaDevices?.enumerateDevices?.()
      .then(rp => { 
        if (!rp[0].deviceId) {
          navigator.mediaDevices.getUserMedia({ video: true })
          .then(rp1 => {
              rp1?.getTracks().forEach((d: any) => {d.stop();  props.getPermission?.(true); }) 
          })
          .catch(e => { props.getPermission?.(false); })
        }
        else props.getPermission?.(true); 
      });
    }
    
    React.useEffect( () =>  {
      if (props.getPermission) getPermission();
      if (props.shotTimeout) setTimeout(captureImage, Math.max(props.shotTimeout, 2000));
    }, [props.getPermission, props.shotTimeout]);

    const capture = () => {
      if (props.stop) return;

      return (
        <Grid id={props.id} position='fixed' container width={width} height={height} sx={{left: props.hide? -width - 100 : 0, zIndex: 100}}>
          {img?
            <Transition type='zoom' addTime={-900} play={img !== null}>
              <img src={img} />
            </Transition>
          : 
            <WebcamReact
              audio={props.audio || false}
              muted={false}
              mirrored={true}
              ref={webcamRef}
              screenshotFormat='image/png'
              videoConstraints={videoConstraints}
              width={width}
              height={height}
            />
          }
            <Button type='contained' startIcon={img? 'videocam' : 'photo_camera'} sx={{position: 'absolute', zIndex: 100, m: 0.5}} onClick={img? () => setImg(null) : captureImage} />
        </Grid>
      );
    }

    return (
      <>
      {capture()}
      </>
    )
}
